import type { SVGProps } from "react";
import * as React from "react";
const SvgFolderOpen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.533 10H24l-2 11H2L0 3h5.563a3 3 0 0 1 2.338 1.12L9.414 6H20l.533 4ZM8.457 8 6.343 5.373A1 1 0 0 0 5.563 5H2.235l1.014 9.13L4 10h14.516l-.267-2H8.457Zm-4.06 11 1.272-7h15.935l-1.273 7H4.396Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFolderOpen;
